import { render, staticRenderFns } from "./SearchSpeakerTravelsFrom.vue?vue&type=template&id=edde23ba&"
import script from "./SearchSpeakerTravelsFrom.vue?vue&type=script&lang=js&"
export * from "./SearchSpeakerTravelsFrom.vue?vue&type=script&lang=js&"
import style0 from "./SearchSpeakerTravelsFrom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports